/* Localise only known Findter control text nodes and accessible labels. */
(() => {
  'use strict';

  if (window.__vdvFindterLocalization) return;

  const configElement = document.getElementById('vdv-findter-localization-config');
  if (!configElement || !window.MutationObserver) return;

  let config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (_) {
    return;
  }

  const locale = String(config.locale || '').toLowerCase().split('-')[0];
  if (!['nl', 'fr', 'en'].includes(locale) || !config.labels || !config.filterBy || !config.sort) return;
  window.__vdvFindterLocalization = true;

  const rootId = 'fdt-search-filters-app';
  const headingSelector = 'button.search-filters__filter-option-title';
  const filterListSelector = 'ul.search-filters__filter-option-listitem';
  const filterInputSelector = 'input.search-filters__filter-option-item-button';
  const filterValueSelector = 'span.search-filters__filter-option-item-label';
  const sortInputSelector = 'input.search-filters__sort-option-item-input[name="sort"]';
  const sortValueSelector = 'span.search-filters__sort-option-item-label';
  const sortSelectedSelector = 'span.search-filters__sort-value';
  const sortListSelector = 'ul.search-filters__sort-list';
  const activeGroupSelector = 'span.search-filters__filter-option-active-tag-label-content';
  const activeValueSelector = 'span.search-filters__filter-active-tag-item-label';
  const backToTopSelector = 'div.search-filters__scroll-to-top-btn[role="button"]';
  const controlSelector = [headingSelector, filterListSelector, filterInputSelector,
    filterValueSelector, sortInputSelector, sortValueSelector, sortSelectedSelector, sortListSelector,
    activeGroupSelector, activeValueSelector, backToTopSelector].join(',');
  const normalise = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const driveAliases = {
    'ak batterij': 'ak_battery',
    'ap batterij': 'ap_battery',
    'as batterij': 'as_battery',
    benzine: 'petrol',
    elektrisch: 'electric'
  };
  const aliases = {
    availability: ['Beschikbaarheid', 'Availability'],
    price: ['Prijs', 'Price'],
    brand: ['Brand', 'Merk'],
    drive_type: ['Aandrijving'],
    weight: ['weight', 'Gewicht'],
    power: ['Vermogen'],
    motor_power: ['Motorvermogen'],
    max_pressure: ['Max Bar'],
    tank_capacity: ['Ketel inhoud'],
    working_length: ['Werklengte'],
    diameter: ['Diameter'],
    connection: ['Aansluiting'],
    material: ['Material', 'Materiaal'],
    quality: ['Kwaliteit', 'Quality'],
    type: ['Type'],
    bore: ['Asgat'],
    overall_length: ['Totale lengte'],
    teeth: ['Tanden'],
    working_width: ['Werkbreedte'],
    cutting_disc: ['Doorslijpschijf'],
    cutting_depth: ['Snijdiepte'],
    saw_blade_diameter: ['Doorsnede zaagblad'],
    max_cutting_depth: ['Max. zaagdiepte'],
    stroke_height: ['Slaghoogte']
  };
  const lookup = new Map();
  Object.entries(aliases).forEach(([key, values]) => {
    if (typeof config.labels[key] !== 'string' || !config.labels[key].trim()) return;
    [...values, config.labels[key]].forEach((value) => lookup.set(normalise(value), key));
  });

  const setAriaLabel = (element, label) => {
    if (label && element.getAttribute('aria-label') !== label) element.setAttribute('aria-label', label);
  };
  const setDirectText = (element, label) => {
    if (typeof label !== 'string' || !label) return;
    const nodes = Array.from(element.childNodes).filter((node) => node.nodeType === Node.TEXT_NODE && node.nodeValue.trim());
    const current = nodes.map((node) => node.nodeValue).join('').replace(/\s+/g, ' ').trim();
    if (current === label) return;
    nodes.forEach((node, index) => {
      const leading = node.nodeValue.match(/^\s*/)[0];
      const trailing = node.nodeValue.match(/\s*$/)[0];
      const value = `${leading}${index === 0 ? label : ''}${trailing}`;
      if (node.nodeValue !== value) node.nodeValue = value;
    });
  };
  const sortAriaLabel = (value) => typeof config.sortBy === 'string' ? config.sortBy.split('[value]').join(value) : '';

  const localiseHeading = (button) => {
    const textNodes = Array.from(button.childNodes).filter((node) => node.nodeType === Node.TEXT_NODE);
    const visibleNodes = textNodes.filter((node) => node.nodeValue.trim());
    if (!visibleNodes.length) return;

    const currentText = textNodes.map((node) => node.nodeValue).join('').replace(/\s+/g, ' ').trim();
    const isSort = button.id === 'sort';
    let key = lookup.get(normalise(currentText));
    if (!isSort && !key) {
      // Findter keeps the original label in the ID. Use its exact suffix only;
      // the metafield source prefix must never determine a label's meaning.
      const id = normalise(button.id);
      for (const [alias, candidate] of lookup) {
        if (id.endsWith(`-${alias}`)) {
          key = candidate;
          break;
        }
      }
    }
    const label = isSort ? config.sort : config.labels[key];
    if (!label) return;

    setDirectText(button, label);
    const ariaLabel = isSort ? label : config.filterBy.split('[label]').join(label);
    setAriaLabel(button, ariaLabel);
    return { key, label, isSort };
  };

  const localiseFilter = (button) => {
    const group = localiseHeading(button);
    const wrapper = button.closest('filter-option');
    if (!group || !wrapper) return;
    wrapper.querySelectorAll(filterListSelector).forEach((list) => setAriaLabel(list, group.label));
    wrapper.querySelectorAll(filterInputSelector).forEach((input) => {
      const valueElement = input.closest('label')?.querySelector(filterValueSelector);
      if (!valueElement) return;
      let translatedValue;
      if (group.isSort && input.name === 'sort') {
        translatedValue = config.sortOptions?.[input.value];
      } else if (group.key === 'drive_type' && input.name === 'metafield_custom_dikteaandrijfschakel') {
        translatedValue = config.driveValues?.[driveAliases[normalise(input.value)]];
      }
      setDirectText(valueElement, translatedValue);
      const value = valueElement.textContent.replace(/\s+/g, ' ').trim();
      if (!value) return;
      if (group.isSort) {
        setAriaLabel(input, sortAriaLabel(value));
      } else if (typeof config.filterValue === 'string') {
        setAriaLabel(input, config.filterValue.split('[label]').join(group.label).split('[value]').join(value));
      }
    });
  };

  const localiseSortOptions = () => {
    root.querySelectorAll(sortListSelector).forEach((list) => setAriaLabel(list, config.sort));
    root.querySelectorAll(sortInputSelector).forEach((input) => {
      const valueElement = input.closest('label')?.querySelector(sortValueSelector);
      if (!valueElement) return;
      setDirectText(valueElement, config.sortOptions?.[input.value]);
      const value = valueElement.textContent.replace(/\s+/g, ' ').trim();
      if (!value) return;
      setAriaLabel(input, sortAriaLabel(value));
      if (input.getAttribute('aria-selected') === 'true') {
        const sortButton = input.closest('sort-button');
        const selectedValue = sortButton?.querySelector(sortSelectedSelector);
        if (selectedValue) setDirectText(selectedValue, value);
        if (sortButton) setAriaLabel(sortButton, sortAriaLabel(value));
      }
    });
  };

  const localiseActiveTags = () => {
    root.querySelectorAll('.search-filters__filter-active-tag-wrapper').forEach((wrapper) => {
      const groupLabel = wrapper.querySelector(activeGroupSelector);
      if (!groupLabel) return;
      const key = lookup.get(normalise(groupLabel.textContent.replace(/:\s*$/, '')));
      if (!key) return;
      setDirectText(groupLabel, `${config.labels[key]}:`);
      if (key !== 'drive_type') return;
      wrapper.querySelectorAll('filter-tag-item[data-key="metafield_custom_dikteaandrijfschakel"]').forEach((tag) => {
        const valueLabel = tag.querySelector(activeValueSelector);
        if (!valueLabel) return;
        const valueKey = driveAliases[normalise(tag.getAttribute('data-value'))];
        setDirectText(valueLabel, config.driveValues?.[valueKey]);
      });
    });
  };

  let root = null;
  let scheduled = false;
  const options = { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'aria-selected'] };
  const apply = () => {
    scheduled = false;
    if (!root || !root.isConnected) return;
    // Do not observe our own text/aria edits: this prevents feedback loops.
    controlsObserver.disconnect();
    root.querySelectorAll(headingSelector).forEach(localiseFilter);
    localiseSortOptions();
    localiseActiveTags();
    root.querySelectorAll(backToTopSelector).forEach((button) => setAriaLabel(button, config.backToTop));
    controlsObserver.observe(root, options);
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(apply);
  };
  const affectsControl = (record) => {
    if (record.type === 'characterData') return record.target.parentElement?.matches(controlSelector);
    if (record.type === 'attributes') return record.target.matches(controlSelector);
    if (record.target.matches?.(controlSelector)) return true;
    return Array.from(record.addedNodes).some((node) => node.nodeType === Node.ELEMENT_NODE &&
      (node.matches(controlSelector) || node.querySelector(controlSelector)));
  };
  const controlsObserver = new MutationObserver((records) => {
    if (records.some(affectsControl)) schedule();
  });
  const attach = () => {
    const nextRoot = document.getElementById(rootId);
    if (nextRoot === root) return;
    controlsObserver.disconnect();
    root = nextRoot;
    if (root) apply();
  };
  // Findter can mount late or replace its root. This watcher only discovers
  // that root; text and aria observation remains scoped to the app itself.
  const rootObserver = new MutationObserver(() => {
    if (!root || !root.isConnected) attach();
  });
  const start = () => {
    rootObserver.observe(document.body, { childList: true, subtree: true });
    attach();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
